import colors from "styles/colors";
export default {
    color: colors["brand-enterprise-dark"]
};
